import { useLocation } from "react-router-dom";
import SEOHead from "./SEOHead";
import { getPageSeo } from "@/lib/page-seo";

/** Applies unique title/description/canonical for static routes.
 *  Pages that render their own SEOHead (service pages, blog posts) override this. */
const RouteSeo = () => {
  const { pathname } = useLocation();
  const seo = getPageSeo(pathname);
  if (!seo) return null;
  return (
    <SEOHead
      title={seo.title}
      description={seo.description}
      canonical={seo.canonical}
      noindex={seo.noindex}
      jsonLd={seo.jsonLd}
    />
  );
};

export default RouteSeo;
